import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { createEntityAppointment } from 'api/Appointment';

import { formatDate } from 'lib/helpers/utility';

import Configurations from 'components/Payments/Configurations';
import Button from 'components/shared/Buttons/Button';
import Modal from 'components/shared/Modal/Modal';
import Allowed from 'components/shared/Permissions/Allowed';

import './Payments.scss';

const Payments = ({
  amount,
  patientId,
  practiceId,
  appointmentId,
  invoiceId,
  smallButton,
  updateBalance = () => {
    console.warn(`${__filename} No updateBalance handler`);
  },
  updateAmount = () => {
    console.warn(`${__filename} No updateAmount handler.`);
  },
  onSuccess = () => {
    console.warn(`${__filename} No onSuccess handler.`);
  },
  surcharge,
  preAuthForm,
  showTransactionOverride = false,
  setAppointmentPayments,
  appointment,
  apptInvoice = false,
  setAppointment,
  buttonClassName,
  setAppointmentId
}) => {
  const [showTransaction, setShowTransaction] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onClose = () => {
    setShowTransaction(false);
    updateBalance(0);
  };

  const handleOnPayment = async () => {
    setLoading(true);
    if (appointment?.isRecurrence && !appointment.parent_appointment_id) {
      const params = {
        appointment_id: appointment.id,
        appointment_date: {
          starts_at: appointment.starts_at,
          ends_at: appointment.ends_at,
          deleted_date: formatDate(appointment.starts_at)
        },
        type: 'action'
      };

      const { code, updatedAppointment } = await createEntityAppointment(navigate, params);
      if (code === 0 && updatedAppointment.id) {
        setAppointmentId(updatedAppointment.id);
      }
      localStorage.setItem('openPayment', true);
    } else {
      setShowTransaction(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (localStorage.getItem('openPayment')) {
      setShowTransaction(true);
      localStorage.removeItem('openPayment');
    }
  }, []);

  if (!patientId) return <div>No payment target.</div>;

  if (showTransaction || showTransactionOverride) {
    return (
      <Modal
        slideFromRight
        isFooter={false}
        handleClose={onClose}
        handleClick={onClose}
        className="p-0"
        isLarge
        handleOpen={showTransaction}
        bodyClassName="p-0 max-h-screen"
        title={preAuthForm ? 'Pre Authorization' : 'New Payment'}>
        <Configurations
          amount={amount}
          patientId={patientId}
          practiceId={practiceId}
          invoiceId={invoiceId}
          appointmentId={appointmentId}
          surcharge={surcharge}
          onClose={onClose}
          updateBalance={updateBalance}
          updateAmount={updateAmount}
          onSuccess={onSuccess}
          preAuthForm={preAuthForm}
          setAppointmentPayments={setAppointmentPayments}
          appointment={apptInvoice ? appointment : {}}
          setAppointment={apptInvoice ? setAppointment : null}
        />
      </Modal>
    );
  }

  return (
    <Allowed requiredPermissions="payments.create">
      <Button
        text="New Payment"
        data-qa="new-payment-btn"
        size={smallButton ? 'small' : 'medium'}
        icon="wallet-add-mono"
        iconColor="white"
        iconSize={18}
        onClick={handleOnPayment}
        className={buttonClassName || 'h-[38px] w-max'}
        disabled={loading}
        loading={loading}
      />
    </Allowed>
  );
};

export default Payments;
